import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { SubscriptionProvider } from "./contexts/SubscriptionContext";
import AppRoutes from "./components/AppRoutes";

function App() {
  // const detectAndStoreEnvironment = () => {
  //   const hostname = window.location.hostname;

  //   let environment = ""; // default
  //   if (hostname.includes("test")) {
  //     environment = "test";
  //   }
  //   if (hostname.includes("dev")) {
  //     environment = "dev";
  //   }

  //   localStorage.setItem("app_environment", environment);
  // };

  // useEffect(() => {
  //   detectAndStoreEnvironment();
  // }, []);

  return (
    <BrowserRouter>
      <SubscriptionProvider>
        <AppRoutes />
        <Toaster />
      </SubscriptionProvider>
    </BrowserRouter>
  );
}

export default App;
